import * as ko from "knockout";
import * as _ from "underscore";
import { App } from "../app";
import { Api } from "../app-api";
import { Cart } from "../app-cart";
import { Gtm } from "../app-gtm";
import { Toastr } from "../app-models";

const divRoot: HTMLDivElement = document.querySelector("#ko-account");
const divModel: HTMLDivElement = document.querySelector("#divAccountModel");

export class Child {
    id: number;
    name: string;
    url: string;

    constructor(data) {
        let self = this;

        self.id = data.id;
        self.name = data.name;
        self.url = Api.GetUrl("account/child/" + data.id);
    }
}

export class Order {
    id: number;
    child: Child;
    location: string;
    dates: string;
    map: string;
    uri: string;

    showDetails: () => void;

    constructor(data, root: ViewModel) {
        let self = this;

        self.id = data.id;
        self.child = new Child(data.child);
        self.location = data.location;
        self.dates = data.dates;
        self.map = data.map;
        self.uri = "/account/order/" + data.id;

        self.showDetails = () => {
            root.showDetails(self.id);
        }
    }
}

export class OrderDetails {
    id: number;
    created: string;

    constructor(data) {
        let self = this;

        self.id = data.id;
        self.created = data.created;
    }
}

export class ViewModel {
    id: number;
    credit: string;
    email: string;
    name: string;
    nextUrl: string;

    children: Child[];
    orders: Order[];

    cart = ko.observable<Cart>();
    creditCard = ko.observable();
    //details = ko.observable<OrderDetails>();
    details = ko.observable();

    next: () => void;
    removeCreditCard: () => void;
    showDetails: (id: number) => void;

    constructor(model) {
        let self = this;

        let data = JSON.parse(model);

        self.id = data.id;
        self.credit = data.credit;
        self.email = data.email;
        self.name = data.name;
        self.nextUrl = data.nextUrl;

        self.creditCard(data.creditCard);

        self.children = _(data.children).map(x => new Child(x));
        self.orders = _(data.orders).map(x => new Order(x, self));

        if (data.cart) { self.cart(new Cart(data.cart, data.returnUrl)); }

        self.details.subscribe(newVal => {
            $("#orderDetailsModal").modal(newVal ? "show" : "hide");
        });

        self.removeCreditCard = () => {
            if (!self.creditCard()) { return; }

            let msg = "Remove Payment Method '" + self.creditCard().number + "'";

            if (!Toastr.confirm(msg)) { return; }

            Api.RemoveCreditCard({ id: self.id })
                .done(results => {
                    if (results.error) { return App.alertError(results.message); }
                    self.creditCard(null);
                });
        }

        self.showDetails = (id: number) => {
            Api.GetOrderDetails({ id: id })
                .done(results => {
                    if (results.error) { return App.alertError(results.message); }
                    //self.details(new OrderDetails(results));
                    self.details(results);
                });
        }

        self.next = () => {
            if (self.validate())
                window.location.href = self.nextUrl;
        }

        Gtm.account(self.cart())
    }

    private validate(): boolean {
        let self = this;

        if (self.cart() && !_(self.children).any())
        {
            App.alertWarning("Add a child to continue with registration.");

            return false;
        }

        return true;
    }
}

function init() {
    if (divModel) {
        ko.applyBindings(new ViewModel(divModel.textContent), divRoot);
    }
}

$(document).ready(() => init());